import { createStore } from 'vuex';
import user from './user';
import business from './business';
import lead from './lead';
import leadSelection from './leadSelection';
import metrics from './metrics';
import reviews from './reviews';
import integration from './integration';

export default createStore({
  modules: {
    user,
    business,
    lead,
    leadSelection,
    metrics,
    reviews,
    integration,
  },
  state: {
    // For any type of loading
    isLoading: true,
    // To hide view entirely when we are checking authorization
    globalIsLoading: false,
    variant: '',
    message: {
      msgHasLink: false,
      msg1: '',
      msg2: '',
      msgLinkText: '',
      msgLink: '',
    },
    localeOptions: [
      {
        text: 'en',
        value: 'en_CA',
      },
      {
        text: 'fr',
        value: 'fr_CA',
      },
    ],
  },
  mutations: {
    SET_LOADING(state, is) {
      state.isLoading = is;
    },
    SET_GLOBAL_LOADING(state, is) {
      state.globalIsLoading = is;
      state.isLoading = is;
    },
    SET_MESSAGE(state, { variant, message }) {
      state.message = message;
      state.variant = variant;
    },
  },
  getters: {
    showAlert(state) {
      return state.message.msg1 !== '';
    },
  },
  strict: true,
  actions: {
    resetErrorMessage({ commit }) {
      commit('SET_MESSAGE', {
        variant: '',
        message: {
          msgHasLink: false,
          msg1: '',
          msg2: '',
          msgLinkText: '',
          msgLink: '',
        },
      });
    },
  },
});
